import { Injectable } from '@angular/core';
import { ServerService } from './ServerService';

export enum EnumTipoJobImpressao {
  PEDIDO = 'PEDIDO',
  NFCe = 'NFCe',
  RELATORIO = 'RELATORIO',
  COMPROVANTE = 'COMPROVANTE'
}


@Injectable({
  providedIn: 'root'
})
export class JobImpressaoService extends ServerService {

  listeJobs(query?: any): Promise<any> {
    let enpoint  = '/jobs-impressao';

    if(query.servidorImpressao)
      enpoint = `${enpoint}/servidor/${query.servidorImpressao}`

    return this.obtenha(enpoint, query)
  }

  // Método para listar histórico de jobs concluídos com paginação
  listeJobsHistorico(servidorImpressao: number, pagina: number = 1, itensPorPagina: number = 10,
                     filtro: any = {}): Promise<any> {
    let  enpoint = `/jobs-impressao/servidor/${servidorImpressao}/historico`

    filtro.pagina = pagina;
    filtro.itensPorPagina = itensPorPagina;

    return this.obtenha(enpoint, filtro);
  }

  selecioneSync(id: number): Promise<any> {
    return this.obtenha(`/jobs-impressao/${id}`, {});
  }

  salveJob(jobImpressao: any): Promise<any> {
    return this.facaPost('/jobs-impressao', jobImpressao);
  }

  atualizeSync(jobImpressao: any): Promise<any> {
    return this.facaPut(`/jobs-impressao/${jobImpressao.id}`, jobImpressao);
  }

  atualizeStatus(jobId: number, status: any, erro?: string): Promise<any> {
    return this.facaPut(`/jobs-impressao/${jobId}/status`, { status, erro });
  }

  canceleJob(jobId: number): Promise<any> {
    return this.remova(`/jobs-impressao/${jobId}/cancelar`, {});
  }

  reexecuteJob(jobId: number): Promise<any> {
    return this.facaPost(`/jobs-impressao/${jobId}/reexecutar`, {});
  }

  listeJobsPorServidor(servidorId: number): Promise<any[]> {
    return this.obtenha(`/jobs-impressao/servidor/${servidorId}/pendentes`, {});
  }

  obtenhaEstatisticas(): Promise<any> {
    return this.obtenha('/jobs-impressao/estatisticas', {});
  }

  limpeJobsExpirados(): Promise<any> {
    return this.facaPost('/limpar-expirados', {});
  }

  removaJob(jobId: number): Promise<any> {
    return this.remova(`/jobs-impressao/${jobId}`, {});
  }



  // Método para criar job de impressão de pedido
  crieJobPedido(pedido: any, impressora: any, prioridade: number = 2): Promise<any> {
    return this.salveJob({
      tipo: EnumTipoJobImpressao.PEDIDO,
      pedido: pedido,
      impressora: impressora,
      prioridade: prioridade
    } as any);
  }

  // Método para criar job de impressão de NFCe
  crieJobNFCe(dados: any, impressoraId: number, prioridade: number = 1): Promise<any> {
    return this.salveJob({
      tipo: EnumTipoJobImpressao.NFCe,
      impressoraId: impressoraId,
      prioridade: prioridade
    } as any);
  }

  // Método para criar job de impressão de relatório
  crieJobRelatorio(dados: any, impressoraId: number, prioridade: number = 3): Promise<any> {
    return this.salveJob({
      tipo: EnumTipoJobImpressao.RELATORIO,
      impressoraId: impressoraId,
      prioridade: prioridade
    } as any);
  }
}
